import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import {withStyles} from '@material-ui/core/styles';
import * as Constants from "../../consts/Constants.js";

  const CustomCheckbox = withStyles({
    root: {
     color: Constants.COLOR_PRIMARY,
     '&$checked': {
       color: Constants.COLOR_PRIMARY_DARK,
     },
    },
    checked: {},
  })(props => <Checkbox color="default" {...props} />);

export {CustomCheckbox};
